export default "__VITE_ASSET__Bn336ZYU__"